import React, { useEffect, useMemo, useState } from "react";
import Buttons from "../../components/ui/button/Buttons";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import { decryptAESID } from "../../utils/Encryption";
import { useCaseOfficerServiceContext, validateRequirementFiles, validateSectionBMinimumCriteria, validateSections } from "./ServiceContext";
import { useLazyGetSelfEvalutionIdByAppIdQuery } from "../../app/services/SelfEvaluationForm/selfEvalutionServiceApi";
import { useProcessForCretificateGroupingMutation, useRejectSelfEvalutionApplicationByCaseOfficerMutation, useSaveSelfEvalutionFormInfomationByCaseOfficerMutation, useSendClarificationForExistingRequirementMutation, useLazyGetPeerReviewEvaluationDetailsByIdQuery, useLazyGetMinimumCriteriaForServiceByApplicationIdQuery } from "../../app/services/selfEvalutionReviewService/selfEvalutionReviewServiceApi";
import ToastService from "../../services/toastService/ToastService";
import SwalAlert from "../../services/swalService/SwalService";
import SectionA from "./components/SectionA";
import SectionB from "./components/SectionB";
import { useAddAuditLogForProductAndServiceApplicationMutation, useLazyGetDropDownsForProductsAndServicesQuery } from "../../app/services/productAndService/productAndServiceApi";
import { getAuthProps } from "../../lib/authenticationLibrary";
import { useAddAuditLogForSGBPApplcation } from "../../utils/AuditLogQuery/addAuditLog";



const ServiceReviewForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state, dispatch } = useCaseOfficerServiceContext();
  const sectionCCount = state.sectionCCount;
  const sectionCFileCount = state.sectionCFileCount;
  const { error, success, confirm } = SwalAlert();
  let authData = getAuthProps();
  const routeMap = {
    10: "CertificateGroupingWithRating",
    11: "CertificateGroupingWithoutRating",
  };

  const [isSendClarification, setIsSendClarification] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [tempId, setTempId] = useState(null);
  const [isReject, setIsReject] = useState(false);
  const [rejectReasonOptions, setRejectReasonOptions] = useState([]);
  const [rejectData, setRejectData] = useState({
    reason: null,
    comment: "",
  });
  const [rejectErrors, setRejectErrors] = useState({
    reason: "",
    comment: "",
  });
  const [getSelfEvaluationId, { isLoading: selfEvaluationIdIsLoading, isSuccess: selfEvaluationIdIsSuccess, data: selfEvaluationIdData, },] = useLazyGetSelfEvalutionIdByAppIdQuery();
  const [saveInfomationByCaseOfficer, { isLoading: saveInfomationByCaseOfficerIsLoading, isSuccess: saveInfomationByCaseOfficerIsSuccess, data: saveInfomationByCaseOfficerData }] = useSaveSelfEvalutionFormInfomationByCaseOfficerMutation();
  const [rejectSelfEvalutionApplication, { isLoading: rejectApplicationIsLoading, isSuccess: rejectApplicationIsSuccess, data: rejectApplicationData }] = useRejectSelfEvalutionApplicationByCaseOfficerMutation();
  const [SendClarificationForExistingRequirement, { isLoading: SendClarificationForExistingRequirementLoading, isSuccess: SendClarificationForExistingRequirementSuccess, data: SendClarificationForExistingRequirementData }] = useSendClarificationForExistingRequirementMutation();
  const [ProcessForCretificateGrouping, { isLoading: ProcessForCretificateGroupingLoading, isSuccess: ProcessForCretificateGroupingSuccess, data: ProcessForCretificateGroupingData }] = useProcessForCretificateGroupingMutation();
  const [getPeerReviewEvaluationDetailsById, { isLoading: getPeerReviewEvaluationDetailsByIdLoading, isSuccess: getPeerReviewEvaluationDetailsByIdSuccess, data: getPeerReviewEvaluationDetailsByIdData, },] = useLazyGetPeerReviewEvaluationDetailsByIdQuery();
  const [getDropDownsForProductsAndServices, { isLoading: dropDownsLoading, isSuccess: dropDownsSuccess, data: dropDownsData }] = useLazyGetDropDownsForProductsAndServicesQuery();
  const [getMinimumCriteriaForService, { data: minimumCriteria, isLoading: minimumCriteriaLoading }] = useLazyGetMinimumCriteriaForServiceByApplicationIdQuery();
  const { addAuditLog } = useAddAuditLogForSGBPApplcation();
  const hasAnyStatus = useMemo(() => {
    const sections = ["A"];
    return sections.some((section) =>
      Object.values(state?.sections?.[section]?.requirements || {}).some(
        (req) => req?.status != null && (req?.status === "Rejected" || req?.status === "Pending Review" || req?.status === "Clarification (R)")
      )
    );
  }, [state?.sections?.A?.requirements, state?.sections?.B?.requirements]);

  useEffect(() => {
    if (dropDownsSuccess && dropDownsData) {
      setRejectReasonOptions(dropDownsData.filter((item) => item?.dropdownName === "Application Discontinue")?.map((item) => ({
        value: item.id,
        label: item.name,
      })) || []);
    }
  }, [dropDownsSuccess, dropDownsData, dropDownsLoading]);

  //  may be use for section 2
  const hasAnyStatusForB = useMemo(() => {
    const sections = ["B"];
    const sectionABCheck = sections.some((section) => Object.values(state?.sections?.[section]?.requirements || {}).some((req) => req?.status != null && (req?.status === "Pending Review" || req?.status === "Clarification (R)")));
    return sectionABCheck
  }, [state?.sections?.B?.requirements,]);

  const hasPendingClarification = useMemo(() => {
    const sections = ["A", "B"];
    return sections.some((section) =>
      Object.values(state?.sections?.[section]?.requirements || {}).some(
        (req) => req?.status != null && req?.status === "Pending Clarification"
      )
    );
  }, [state?.sections?.A?.requirements, state?.sections?.B?.requirements]);

  const handleSaveForm = async () => {
    let { sections } = state;
    const payload = {
      // SGBPSAppplicationId: id,
      SelfEvaluationId: selfEvaluationIdData?.selfEvaluationId || null,
      SaveSelfEvalutionFileUploadListByCaseOfficerRequest: [],
      SaveSelfEvalutionAdditionalFieldValueListByCaseOfficerRequest: [],
      SaveSelfEvalutionRequirementListByCaseOfficerRequest: []
    };

    // --- Global sets to deduplicate files 
    const seenFileIds = new Set();
    const seenNewFileNames = new Set();
    Object.entries(sections).forEach(([sectionKey, sectionValue]) => {
      // --- Files
      Object.entries(sectionValue.requirements || {}).forEach(
        ([requirementId, requirementData]) => {
          (requirementData.files || []).forEach((file) => {
            const isNewFile = typeof file.id === "string";
            if (isNewFile) {
              if (seenNewFileNames.has(file.name)) return;
              seenNewFileNames.add(file.name);
            } else {
              if (seenFileIds.has(file.id)) return;
              seenFileIds.add(file.id);
            }
            payload.SaveSelfEvalutionFileUploadListByCaseOfficerRequest.push({
              FileId: isNewFile ? null : file.id || null,
              SelfEvalRequirementId: file?.selfEvalRequirementId || requirementData?.selfEvalRequirementId || null,
              FileName: file.name || null,
              FilePath: file.url || null,
            });
          });
        }
      );
      Object.entries(sectionValue.requirements || {}).forEach(
        ([requirementId, requirementData]) => {
          if (requirementData?.selfEvalRequirementId != null && requirementData?.selfEvalRequirementId != undefined) {
            payload.SaveSelfEvalutionRequirementListByCaseOfficerRequest.push({
              SelfEvalRequirementId: requirementData?.selfEvalRequirementId || null,
              CaseOfficerCommentsForRequirement: requirementData?.caseOfficerComments || null,
            });
          }
        }
      );

      Object.entries(sectionValue?.fields || {}).forEach(
        ([fieldId, fieldData]) => {
          payload.SaveSelfEvalutionAdditionalFieldValueListByCaseOfficerRequest.push({
            SelfEvaluationAdditionalFieldId: fieldData?.id || null,
            SelfEvalRequirementId: fieldData?.selfEvalRequirementId || null,
            AdditionalFieldId: Number(fieldData?.additionalFieldId),
            AdditonalFieldValue: String(fieldData?.value) || null,
            Comments: fieldData?.comment || null,
            ProductDetailsId: fieldData?.brandItemId || null,
          });
        }
      );

    });

    const fileValidation = validateRequirementFiles(state);
    if (!fileValidation.valid) {
      error(fileValidation.message);
      return;
    }

    const allValid = validateSections(state, {
      A: state.sections?.A?.fieldList || [],
      B: state.sections?.B?.fieldList || [],
    },
      {
        A: Object.keys(state.sections?.A?.fields || {}),
        B: Object.keys(state.sections?.B?.fields || {}),
      }
    );

    // validation call if any required field is empty
    if (!allValid) {
      error("Please fill in all required fields before submitting.");
      return;
    }
    const minCriteriaCheck = validateSectionBMinimumCriteria(state);
    if (!minCriteriaCheck.valid) {
      error(minCriteriaCheck.message);
      return;
    }
    // saveInfomationByCaseOfficer(payload);
    try {
      await saveInfomationByCaseOfficer(payload).unwrap();
      return true;
    } catch (err) {
      error("Failed to save the form.");
      return false;
    }
  }

  const handleReject = () => {
    confirm('Reject?', 'Are you sure you want to reject?', 'Reject', 'Cancel').then((confirmed) => {
      if (confirmed) {
        // handleRejectApplication();
        setIsReject(true);
      }
    });
  };

  const handleRejectChange = (field, value) => {
    setRejectData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Clear particular field error
    setRejectErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const handleRejectApplication = async () => {
    const errors = {
      reason: "",
      comment: "",
    };

    let isValid = true;

    if (!rejectData?.reason) {
      errors.reason = "Please select a rejection reason.";
      isValid = false;
    }


    setRejectErrors(errors);

    if (!isValid) return;
    const editID = await decryptAESID(id, false);
    let req = {
      SGBPProductInformationId: editID,
      DiscontinueReason: rejectData?.reason?.value || null,
      DiscontinueReasonInternalComment: rejectData?.comment || null,
    };

    if (editID > 0) {
      rejectSelfEvalutionApplication(req)
    }
  }

  // ─── BUILD CERTIFICATE GROUPING REQUEST (per brand, min Rating & min Tick across all Section B requirements)
  const buildCertificateGroupingRequest = (applicationId) => {
    const fieldsObj = state.sections?.B?.fields || {};
    const fieldListB = state.sections?.B?.fieldList || [];
    // additionalFieldId -> { isTickRating, isTextBox }
    const fieldTypeMap = {};
    fieldListB.forEach((f) => {
      fieldTypeMap[f.sgbpAdditionalFieldInputId] = {
        // isTickRating: f.isTickRating,
        isRating: f.isRating,
        isTextBox: f.isTextBox,
      };
    });

    // brandKey -> { brandId, ticks: [], textValue }
    const brandMap = {};
    fieldListB.forEach((fieldDef) => {
      const rawFieldId = fieldDef.sgbpAdditionalFieldInputId;
      const type = fieldTypeMap[rawFieldId];
      if (!type) return;
      Object.values(fieldsObj)
        .filter((f) => f.additionalFieldId === rawFieldId)
        .forEach((field) => {
          const brandKey = field.brandItemId ?? "no-brand";
          if (!brandMap[brandKey]) {
            brandMap[brandKey] = {
              brandId: field.brandItemId ?? null,
              ratings: [],
              textValue: null,
            };
          }

          // --- Tick rating: only parse numerically for tick fields
          if (type.isRating) {
            // const numValue = Number(field.value);
            // if (!Number.isNaN(numValue)) {
            //   brandMap[brandKey].ticks.push(numValue);
            // }
            const numValue = Number(field.value);
            if (field.value !== "" && field.value != null && !Number.isNaN(numValue) && numValue !== 0) {
              brandMap[brandKey].ratings.push(numValue);
            }

          }

          // --- Text box: keep the first non-null/non-empty value; if all are null, stays null
          if (type.isTextBox && brandMap[brandKey].textValue == null) {
            const value = field.value;
            if (value !== null && value !== undefined && value !== "") {
              brandMap[brandKey].textValue = value;
            }
          }
        });
    });
    const BrandIdListtRequest = Object.values(brandMap).map(
      ({ brandId, ratings, textValue }) => {
        // Minimum tick rating for this brand (or the no-brand group)
        // const minBrandRating = ratings.length ? Math.max(...ratings) : "";;

        // let rating;
        // if (minBrandRating !== null && sectionCCount != null) {
        //   rating = Math.min(minBrandRating, sectionCCount);
        // } else {
        //   rating = minBrandRating ?? sectionCCount ?? null;
        // }

        const rating = ratings.length ? Math.max(...ratings) : null;

        return {
          BrandId: brandId !== null ? Number(brandId) : null,
          Rating: rating,
          TextValue: textValue || "",
        };
      }
    );

    return {
      SGBPSAppplicationId: applicationId,
      BrandIdListtRequest,
    };
  };

  const handleProcessClick = async () => {
    setIsProcessing(true);
    const saved = await handleSaveForm();

    if (!saved) {
      setIsProcessing(false);
      return;
    }

    try {
      if (hasPendingClarification) {
        setIsSendClarification(true);
        return;
      }
      const applicationId = decryptAESID(id?.toString(), false);
      const req = buildCertificateGroupingRequest(applicationId);

      await ProcessForCretificateGrouping(req).unwrap();
    } catch (err) {
      error("Failed to process certificate grouping.");
      setIsProcessing(false);
    }
  };

  useEffect(() => {
    const editID = decryptAESID(id, false);
    if (editID > 0) {
      getDropDownsForProductsAndServices();
      getSelfEvaluationId(editID);
      getPeerReviewEvaluationDetailsById(editID)
      getMinimumCriteriaForService(editID);
    }
  }, [id]);

  useEffect(() => {
    if (!selfEvaluationIdIsLoading && selfEvaluationIdIsSuccess) {
      setTempId(selfEvaluationIdData?.templateId);
      ["A", "B"].forEach((section) => {
        dispatch({
          type: "SET_SELF_EVALUATION_ID",
          section,
          selfEvaluationId: selfEvaluationIdData?.selfEvaluationId || null,
          applicationStatus: selfEvaluationIdData?.statusName || null,
          isApplicationReturned: selfEvaluationIdData?.isApplicationReturned || false,
        });
      });
    }
  }, [selfEvaluationIdIsSuccess, selfEvaluationIdData, selfEvaluationIdIsLoading]);

  useEffect(() => {
    if (!saveInfomationByCaseOfficerIsLoading && saveInfomationByCaseOfficerIsSuccess && saveInfomationByCaseOfficerData) {
      if (!isProcessing) {
        ToastService.success("Form Submitted Successfully");
      }
    }
  }, [saveInfomationByCaseOfficerIsLoading, saveInfomationByCaseOfficerIsSuccess, saveInfomationByCaseOfficerData]);

  useEffect(() => {
    if (!SendClarificationForExistingRequirementLoading && SendClarificationForExistingRequirementSuccess && SendClarificationForExistingRequirementData) {
      if (!SendClarificationForExistingRequirementData.hasError) {
        ToastService.success("Clarification sent Successfully");
        const editID = decryptAESID(id, false);
        addAuditLog({ SGBPSApplicationId: editID || 0, AuditLogDescription: "Clarification Sent For SGBS Application Self-Evaluation", TriggredTimeStatusId: selfEvaluationIdData?.statusId });
        handleBack();
      } else {
        ToastService.error(SendClarificationForExistingRequirementData.errorMessage);
      }
    }
  }, [SendClarificationForExistingRequirementLoading, SendClarificationForExistingRequirementSuccess, SendClarificationForExistingRequirementData]);

  useEffect(() => {
    if (!minimumCriteriaLoading && minimumCriteria) {
      const value = Number(minimumCriteria?.minimumCriteria) || 0;
      dispatch({ type: "SET_SECTION_B_MIN_CRITERIA", value });
    }
  }, [minimumCriteriaLoading, minimumCriteria]);

  useEffect(() => {
    if (!rejectApplicationIsLoading && rejectApplicationIsSuccess && rejectApplicationData) {

      if (!rejectApplicationData.hasError) {
        ToastService.success("Application has been rejected.")
        closeClarificationModal();
        const editID = decryptAESID(id, false);
        addAuditLog({ SGBPSApplicationId: editID || 0, AuditLogDescription: "Reject SGBS Self Evaluation Application", TriggredTimeStatusId: selfEvaluationIdData?.statusId });
        handleBack();
      } else {
        ToastService.error(rejectApplicationData.errorMessage)
      }
    }
  }, [rejectApplicationIsLoading, rejectApplicationIsSuccess, rejectApplicationData]);

  useEffect(() => {
    if (!ProcessForCretificateGroupingLoading && ProcessForCretificateGroupingSuccess && ProcessForCretificateGroupingData) {
      ToastService.success("Certificate Grouping Processed Successfully");
      setIsProcessing(false);
      const route = routeMap[tempId];
      // navigate(`/CertificateGroupingRequest/${id}`);
      navigate(route ? `/${route}/${id}` : `/CertificateGroupingRequest/${id}`);
    }
  }, [ProcessForCretificateGroupingLoading, ProcessForCretificateGroupingSuccess, ProcessForCretificateGroupingData]);


  const handleBack = () => {
    navigate("/viewApplicationTaskList")
  }

  const handleClarificationSend = () => {
    setIsSendClarification(false);
    let req = {}
    req.sGBPProductInformationId = decryptAESID(id);
    if (req) {
      SendClarificationForExistingRequirement(req)
    }
  };

  const closeClarificationModal = () => {
    setIsSendClarification(false);
    setIsReject(false);
    setRejectErrors({
      reason: "",
      comment: "",
    });
    setRejectData({
      reason: null,
      comment: "",
    });
  };

  return (
    <div className="self-evaluation-page">
      {/* SECTION*/}
      <SectionA />
      <SectionB />
      {/* <SectionC /> */}
      <div className="form-actions">
        <Buttons buttonText='Back' buttonTypeClassName="black-btn btn outline-btn " onClick={handleBack} />

        <Buttons buttonText="Save" buttonTypeClassName="submit-btn btn outline-btn " isLoading={saveInfomationByCaseOfficerIsLoading && !isProcessing} isDisable={saveInfomationByCaseOfficerIsLoading || selfEvaluationIdData?.statusName == "Rejected" || selfEvaluationIdData?.statusName == "Approval" || selfEvaluationIdData?.statusName == "Approved" || selfEvaluationIdData?.statusName == "Discontinued" || selfEvaluationIdData?.statusName == "MUA Endorsed" || isProcessing} onClick={handleSaveForm} />

        <Buttons buttonText="Reject" buttonTypeClassName="reject  btn"
          isDisable={rejectApplicationIsLoading || selfEvaluationIdData?.statusName == "Rejected" || selfEvaluationIdData?.statusName == "Approval" || selfEvaluationIdData?.statusName == "Approved" || selfEvaluationIdData?.statusName == "Discontinued" || selfEvaluationIdData?.statusName == "MUA Endorsed"} onClick={handleReject} />

        <Buttons buttonText="Process" buttonTypeClassName="submit-btn btn outline-btn " isLoading={ProcessForCretificateGroupingLoading || isProcessing} isDisable={hasAnyStatus || hasAnyStatusForB || ProcessForCretificateGroupingLoading || selfEvaluationIdData?.statusName == "Rejected" || selfEvaluationIdData?.statusName == "Approved" || selfEvaluationIdData?.statusName == "Discontinued" || selfEvaluationIdData?.statusName == "MUA Endorsed" || isProcessing} onClick={handleProcessClick} />

      </div>
      <CenterModel
        show={isSendClarification}
        handleClose={closeClarificationModal}
        modelTitle=""
      >
        <div className="model-content">
          <h3 className="model-center-title">There are requirements pending clarification.</h3>
          <p>Send clarification email?</p>
        </div>

        <div className="model-btn-center">
          <Buttons
            buttonTypeClassName="btn btn-yes"
            onClick={handleClarificationSend}
            buttonText="Yes"
          />
          <Buttons
            buttonTypeClassName="btn btn-no"
            onClick={closeClarificationModal}
            buttonText="No"
          />
        </div>
      </CenterModel>

      <CenterModel
        show={isReject}
        handleClose={closeClarificationModal}
        modelTitle="Reject Application"
        modelWidth="w-55"
      >
        <div>
          <Select
            options={rejectReasonOptions}
            className="evalutionselect"
            value={rejectData?.reason}
            onChange={(val) => handleRejectChange("reason", val)}
            placeholder="Select rejection reason"
          />

          {rejectErrors.reason && (
            <div className="text-danger mt-1">
              {rejectErrors.reason}
            </div>
          )}
          <textarea
            placeholder="Enter internal comments"
            value={rejectData?.comment}
            className="form-control mt-2"
            rows="4"
            onChange={(e) =>
              handleRejectChange("comment", e.target.value)
            }
          />

          {rejectErrors.comment && (
            <div className="text-danger mt-1">
              {rejectErrors.comment}
            </div>
          )}
        </div>

        <div className="model-btn-end mt-3">
          <Buttons
            buttonTypeClassName="btn btn-yes"
            onClick={handleRejectApplication}
            buttonText="Yes"
            isLoading={rejectApplicationIsLoading}
            isDisable={rejectApplicationIsLoading}
          />

          <Buttons
            buttonTypeClassName="btn btn-no"
            onClick={closeClarificationModal}
            buttonText="No"
            isDisable={rejectApplicationIsLoading}
          />
        </div>
      </CenterModel>
    </div>
  );
};

export default ServiceReviewForm;
